
import { memo, useEffect, useRef, useState } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  changeSelectSubpage,
  changeDsrPageDisplay
} from '../actions/dsr-actions'
import { logGuestDsrAnalytics } from '../../analytics/actions/dsr-analytics-actions'
import { bindActionCreators } from 'redux'
import RenderSubpageContent from '../components/RenderSubpageContent'
import '../../layout/components/layout/styles/dsr-content.scss'
import DsrDynamicModal from '../messages/DsrDynamicModal'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'
import { manageDsrUrlTags } from '../../global/helpers/url-tag-helpers'
import DsrPageSideMenu from '../components/DsrPageSideMenu'
import useChangeSubpageDisplay from '../../global/hooks/change-subpage-display'

const RenderProspectPreviewContent = ({
  dsrId,
  selectedDisplaySubpage,
  selectedDisplayPageId,
  changeSelectSubpage,
  changeDsrPageDisplay,
  userActionRequiredState,
  showDsrModalState,
  pagesLocalState,
  // Redux states
  dsrPropertiesRedux,
  dsrTeamMembersRedux
}) => {

  const [localState, setLocalState] = useState({
    showDsrModalLoader: false,
    showConfirmationModal: false,
    confirmationType: '',
    postContentToEdit: '',
    replyIdToEdit: '',
    userIdToken: '',
    modalTransferPayload: '',
    postTagProperties: [],
  })

  
  const initRef = useRef(false);
  // const [clickCount, setClickCount]= useState(0)
  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();
  
  const { handleSelectSubpage, clickCount } = useChangeSubpageDisplay();


  useEffect(() => {
    if ((!initRef.current && pagesLocalState)) {
 
      const visiblePages = pagesLocalState.filter(page => page.displayPage === true)

      if (visiblePages.length > 0) {
        selectedDisplaySubpage ? changeSelectSubpage(selectedDisplaySubpage) : changeDsrPageDisplay(visiblePages[0].pageId)
      } else {
        changeDsrPageDisplay('no-visible-pages')
      }

      // TODO: Implement GA for Prospect DSR
      initRef.current = true
    }
}, [pagesLocalState, changeDsrPageDisplay])

  
  const handleChangeUserActionRequired = (newUserActionRequired, modalTransferPayload) => {
    openLaunchdeckModal(newUserActionRequired)
    
    setLocalState((prevState) => ({
      ...prevState,
      modalTransferPayload,
    }))
  }


  const handleDsrModalClose = () => {
    closeLaunchdeckModal()

    setLocalState((prevState) => ({
      ...prevState,
      postIdToEdit: '',
    }))
  }


  const handleOpenPagePreviewMessageModal = () => {
    openLaunchdeckModal("show-preview-page-action-modal")
  }

  useEffect(() => {
    const handleUrlChange = () => {  
      const viewpage = manageDsrUrlTags("viewpage");
      viewpage && handleSelectSubpage("pg__" + viewpage,"")
    };
    
    window.addEventListener("url-changed", handleUrlChange);
  
    return () => {
      window.removeEventListener("url-changed", handleUrlChange);
    };
  
  }, [handleSelectSubpage]);

  return (
    <Flex className='dsr-content__section'>
      <Flex className='dsr-content__container'>
        <Flex direction="column" align="flex-start" w='100%' minHeight="40em">
          <Flex direction="row" align="flex-start" width="100%" height='100%'>
            <Flex bg="white" position='sticky' top='140px'>
              <DsrPageSideMenu
                pageArray={pagesLocalState}
                selectedDisplayPageId={selectedDisplayPageId}
                handleSelectSubpage={handleSelectSubpage}
                headerMenuHeight="140px"
                isPagePreviewMode={true}
                isProspector={true}
              />
            </Flex>
            <Flex
              direction={['column', 'column', 'row', 'row']}
              justify="center"
              flexWrap="wrap"
              width="100%"
              bg='#F4F4F4'
              height='100%'
            >
              <Box       
                key={'page-view-' + clickCount} 
                className="fade-in"
                mt={'3.5em'} w="100%" px="3em" maxWidth='900px' pb='3em'>
               

                {/* Dev Note: This component is to display static public content, sharing RenderSubpageContent with the normal DSR display */}
                <RenderSubpageContent
                  pageArray={pagesLocalState}
                  selectedDisplaySubpage={selectedDisplaySubpage}
                  selectedDisplayPageId={selectedDisplayPageId}
                  dsrTeamMembers={dsrTeamMembersRedux}
                  isPagePreviewMode={true}
                  dsrId={dsrId}
                  dsrActionList={[]} // Currently no MAP for Prospectors
                  dsrProperties={dsrPropertiesRedux}
                  handleOpenSignupOrLoginModal={handleOpenPagePreviewMessageModal}
                  handleSelectSubpage={handleSelectSubpage}
                />
              </Box>
            </Flex>

            <DsrDynamicModal
              dsrId = {dsrId}
              userActionRequired={userActionRequiredState}
              showDsrModal={showDsrModalState}
              showDsrModalLoader={localState.showDsrModalLoader}
              handleDsrModalClose={handleDsrModalClose}
              postTagProperties={localState.postTagProperties}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              modalTransferPayload={localState.modalTransferPayload}
            />

          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )

}

const mapStateToProps = (state) => {
  return {
    userActionRequiredState: state.dsrPopup.UserActionRequired,
    showDsrModalState: state.dsrModal.showDsrModal,
    selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    dsrPagesRedux: state.setDsrPages.pages,
    dsrPropertiesRedux: state.draftDsrProperties.properties,
    dsrTeamMembersRedux: state.dsrTeamMembers.members, // TODO: review
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeSelectSubpage,
      changeDsrPageDisplay,
      logGuestDsrAnalytics,
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(RenderProspectPreviewContent)))
